export type { YardTaskDetails, YardTaskEventPayload } from './yardTaskPresenterShared';

export { useYardTaskFetcherV2 } from './useYardTaskFetcherV2';
export type { UseYardTaskFetcherV2Options } from './useYardTaskFetcherV2';
export type { UseYardTaskFetcherV2Options as UseYardTaskPresenterV2Options } from './useYardTaskFetcherV2';

export { useYardTaskDisplay } from './useYardTaskDisplay';
export type {
  YardTaskDisplayField,
  YardTaskDisplayData,
  UseYardTaskDisplayOptions
} from './useYardTaskDisplay';

import { useYardTaskFetcherV2 } from './useYardTaskFetcherV2';

import type { UseYardTaskFetcherV2Options } from './useYardTaskFetcherV2';

/**
 * Combined fetch + live-update composable. Delegates to {@link useYardTaskFetcherV2}.
 * Pair with {@link useYardTaskDisplay} when fetch is owned by a parent (e.g. list row).
 */
export function useYardTaskPresenterV2(options: UseYardTaskFetcherV2Options) {
  return useYardTaskFetcherV2(options);
}

/**
 * TODO: (welington) consolidate/deduplicate the useYardTaskFetcher, useYardTaskPresenter, useYardTask (will be tackled on OD-3238)
 */
